import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import * as React from 'react';

import classnames from '../utils/classnames.tsx';

const RadioGroup = ({ className, ...props }: React.ComponentPropsWithRef<typeof RadioGroupPrimitive.Root>) => (
    <RadioGroupPrimitive.Root {...props} className={classnames('flex flex-col gap-2', className)} />
);

interface RadioProps extends React.ComponentPropsWithRef<typeof RadioGroupPrimitive.Item> {
    // sm where rows are dense: tables, menus, filter lists
    size?: 'default' | 'sm';
}

// Checkbox's rules, round: filled when chosen, with the dot in the color of the checkbox's check
const Radio = ({ size = 'default', className, ...props }: RadioProps) => (
    <RadioGroupPrimitive.Item
        {...props}
        className={classnames(
            'flex flex-none cursor-pointer items-center justify-center rounded-full border border-solid p-0 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-line-brand-strong',
            size === 'sm' ? 'h-4 w-4' : 'h-5 w-5',
            'border-line-strong bg-surface-weak shadow-control data-[state=unchecked]:hover:border-line-hover data-[state=unchecked]:group-hover:border-line-hover',
            'data-[state=checked]:border-line-transparent data-[state=checked]:bg-surface-brand-strong-default data-[state=checked]:text-content-white data-[state=checked]:shadow-none dark:data-[state=checked]:text-content-black',
            'data-[disabled]:pointer-events-none data-[disabled]:border-line-weak data-[disabled]:bg-surface-medium data-[disabled]:shadow-none',
            'data-[disabled]:data-[state=checked]:border-line-strong data-[disabled]:data-[state=checked]:bg-line-strong',
            className
        )}
    >
        <RadioGroupPrimitive.Indicator
            className={classnames('rounded-full bg-current', size === 'sm' ? 'h-1.5 w-1.5' : 'h-2 w-2')}
        />
    </RadioGroupPrimitive.Item>
);

export default Object.assign(Radio, { Group: RadioGroup });
